import { Box, Flex, Text } from '@chakra-ui/react'
import { DDSTheme } from '@ds/index'
import { ddsTokens } from '@ds/index'
import { Payload } from 'recharts/types/component/DefaultTooltipContent'

type ChartTooltipProps = {
	active?: boolean
	payload?: Payload<any, any>[]
	label?: string
	formatValue?: (value: any, name: string) => string
}

const ChartTooltip = ({
	active,
	payload,
	label,
	formatValue,
}: ChartTooltipProps) => {
	const tokens = ddsTokens[DDSTheme.light]

	if (!active || !payload || payload.length === 0) {
		return null
	}

	const defaultFormatter = (value: any) => {
		if (value === null || value === undefined) return 'No data'
		if (value === 0) return '0'
		return `${Number(value)}`
	}

	const formatFn = formatValue || defaultFormatter

	return (
		<Box
			bg={tokens.primitive.light.gray[900]}
			color={tokens.primitive.light.white[100]}
			p={3}
			borderRadius="md"
			boxShadow="md"
			border="none"
			minWidth="200px"
		>
			<Text
				fontWeight="medium"
				mb={2}
				color={tokens.primitive.light.white[100]}
			>
				{label}
			</Text>

			{payload.map((entry, index) => {
				if (
					entry.value === null ||
					entry.value === undefined ||
					entry.type === 'none'
				) {
					return null
				}

				const displayValue = formatFn(entry.value, entry.name || '')

				const displayName =
					entry.name === 'average' || entry.name === 'Team average'
						? 'Average'
						: entry.name

				return (
					<Flex key={`tooltip-item-${index}`} align="center" gap={2} mb={1}>
						<Box
							width="12px"
							height="10px"
							border={`1px solid ${tokens.primitive.light.white[100]}`}
							backgroundColor={entry.color}
							borderRadius="sm"
						/>
						<Flex
							justify="space-between"
							width="100%"
							color={tokens.primitive.light.white[100]}
						>
							<Text fontSize="sm">{displayName}</Text>
							<Text fontSize="sm" fontWeight="medium">
								{displayValue}
							</Text>
						</Flex>
					</Flex>
				)
			})}
		</Box>
	)
}

export default ChartTooltip
